<template>
  <div>
    <CRow class="align-items-center">
      <CCol md="12">
        <CCard class="mb-3">
          <CCardBody>
            <OrdersLegend
              :statusMap="statusMap"
              class="d-flex justify-start mb-2"
            />
            <CProgress>
              <CProgressBar
                v-for="progress in progressStatus()"
                :key="progress.id"
                :color="`orders-${progress.color}`"
                :value="progress.percentage"
                >{{ progress.value }}</CProgressBar
              >
            </CProgress>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow class="mb-3">
      <CCol md="3">
        <CCard class="h-100">
          <CCardBody>
            <div class="ui-type-display-xl">{{ round.count_orders }}</div>
            <div class="ui-type-display-lg">
              {{ $t("role.orders.rounds.overview.orders") }}
            </div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md="3">
        <CCard class="h-100">
          <CCardBody>
            <div class="ui-type-display-xl">{{ round.count_prods }}</div>
            <div class="ui-type-display-lg">
              {{ $t("role.orders.rounds.overview.articles") }}
            </div>
            <div class="ui-type-subheading text-warning">{{ prodsInfo() }}</div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md="3">
        <CCard class="h-100">
          <CCardBody>
            <div class="ui-type-display-xl">{{ round.count_producers }}</div>
            <div class="ui-type-display-lg">
              {{ $t("role.orders.rounds.overview.procuders") }}
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol md="3">
        <CCard class="h-100">
          <CCardBody>
            <div class="ui-type-display-xl">{{ round.count_wh }}</div>
            <div class="ui-type-display-lg">
              {{ $t("role.orders.rounds.overview.wh") }}
            </div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md="3">
        <CCard class="h-100">
          <CCardBody>
            <div class="ui-type-display-xl">{{ round.count_islands }}</div>
            <div class="ui-type-display-lg">
              {{ $t("role.orders.rounds.overview.island") }}
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getOrderStatusOptions } from "../../../../../../helpers/options";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import { processProgressData } from "../../../../../../helpers/common";
import { roundListProgressMap } from "../../../../../../config/global";
import OrdersLegend from "../../../share/OrdersLegend.vue";

export default {
  name: "ViewOverview",

  components: {
    OrdersLegend,
  },

  computed: {
    ...mapState("rounds", ["round"]),

    statusMap() {
      return roundListProgressMap(this.$i18n);
    },
  },

  methods: {
    prodsInfo() {
      const info = [];
      const status = getOrderStatusOptions(this.$i18n);
      const { tot_status } = this.round;
      Object.keys(tot_status).forEach((key) => {
        const s = status.find((i) => i.value == key);
        if (s) {
          info.push(`${tot_status[key]} ${s.label}`);
        }
      });

      return info.join(" - ");
    },

    progressStatus() {
      const statusMap = get(this.round, "tot_status", {});
      const itemCount = get(this.round, "count_prods", 0);
      console.log(statusMap, itemCount);
      return processProgressData(
        itemCount,
        statusMap,
        cloneDeep(roundListProgressMap(this.$i18n))
      );
    },
  },
};
</script>
